const DOCUMENT = 'POOLS_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  LOAD_MY_TEAM_REQUEST: DOCUMENT + 'LOAD_MY_TEAM',
  LOAD_MY_TEAM_SUCCESS: DOCUMENT + 'LOAD_MY_TEAM_SUCCESS',
  LOAD_AFTER_ACTION: DOCUMENT + 'LOAD_AFTER_ACTION',
  INVITE_AGENCY_SUCCESS: DOCUMENT + 'INVITE_AGENCY_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  SEND_REQUEST: DOCUMENT + 'SEND_REQUEST',
  CHANGE_CHECKED: DOCUMENT + 'CHANGE_CHECKED',
  CLEAR_SELECTION: DOCUMENT + 'CLEAR_SELECTION',
  TOGGLE_BULK_INVITE_ALERT_VISIBILITY: DOCUMENT + 'TOGGLE_BULK_INVITE_ALERT_VISIBILITY',
  LOAD_AVAILABLE_ACTION_REQUEST: DOCUMENT + 'LOAD_AVAILABLE_ACTION_REQUEST',
  LOAD_AVAILABLE_ACTION_SUCCESS: DOCUMENT + 'LOAD_AVAILABLE_ACTION_SUCCESS',
  SELECT_BULK_BY_STATUS: DOCUMENT + 'SELECT_BULK_BY_STATUS',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadMyTeamData: data => ({
    type: actions.LOAD_MY_TEAM_REQUEST,
    payload: data,
  }),

  loadMyTeamDataSuccess: data => ({
    type: actions.LOAD_MY_TEAM_SUCCESS,
    payload: data,
  }),

  loadAfterAction: data => ({
    type: actions.LOAD_AFTER_ACTION,
    payload: data,
  }),

  inviteAgencySuccess: data => ({
    type: actions.INVITE_AGENCY_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  sendRequest: data => ({
    type: actions.SEND_REQUEST,
    payload: data,
  }),

  changeChecked: data => ({
    type: actions.CHANGE_CHECKED,
    payload: data,
  }),

  clearSelection: () => ({
    type: actions.CLEAR_SELECTION,
  }),

  toggleBulkInviteAlertVisibility: data => ({
    type: actions.TOGGLE_BULK_INVITE_ALERT_VISIBILITY,
    payload: data,
  }),

  loadAvailableAction: data => ({
    type: actions.LOAD_AVAILABLE_ACTION_REQUEST,
    payload: data,
  }),

  loadAvailableActionSuccess: data => ({
    type: actions.LOAD_AVAILABLE_ACTION_SUCCESS,
    payload: data,
  }),

  selectBulkByField: status => ({
    type: actions.SELECT_BULK_BY_STATUS,
    payload: status,
  }),
};

export default actions;
